import type { AuthHeaderIconKey } from "./loginNoteIcons";

export const authFlowHeaderIcons = {
  twoFactorApp: "verified_user",
  twoFactorSms: "sms",
  forgotPassword: "mark_email_unread",
  setNewPassword: "lock_reset",
  passwordResetInvalid: "link_off",
  passwordResetSent: "mark_email_read",
  passwordResetComplete: "check_circle",
  changePassword: "lock_reset",
  changePasswordComplete: "check_circle",
  smsNotPossible: "warning_amber",
} as const satisfies Record<string, AuthHeaderIconKey>;
